import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import type { ReactNode } from 'react';
import type { PageDataState } from '../../model/pageData.types';
import { pageDataActions } from '../../model/pageData.slice';

// TODO: This is a placeholder Store type - apps will need to extend this
// The actual Store type will be provided by each app's store
export type Store = {
    requestSlice: PageDataState;
};

export const usePageData = () => {
    const pageDataStore = useSelector((store: Store) => store.requestSlice);
    const dispatch = useDispatch();

    const setPageData = useCallback(
        (data: { title: string; body: ReactNode }) => {
            dispatch(pageDataActions.setPageData(data));
        },
        [dispatch]
    );

    const setExplanationVideo = useCallback(
        (video: string) => {
            dispatch(pageDataActions.setExplanationVideo(video));
        },
        [dispatch]
    );

    const resetPageData = useCallback(() => {
        dispatch(pageDataActions.resetPageData());
    }, [dispatch]);

    return {
        ...pageDataStore,
        setPageData,
        setExplanationVideo,
        resetPageData,
    };
};
